<template>
  <div class="main-containers">
    <div style="width: 51.3%">
      <div class="validate-container">
        <div class="validate_container-stepper">
          <div class="heading-items">
            <p class="actionHedaing">Validate Payroll inputs</p>
            <img src="@/assets/info-2.svg" style="width: 20px" />
          </div>
          <!-- <div style="display: flex; flex-wrap: nowrap; gap: 20px">
            <p style="font-size: 18px; color: #62bdbd; font-weight: 500">
              Select All
            </p>
            <input
              type="checkbox"
              class="custom-checkbox"
              name="check"
              :disabled="checkboxDisabled"
              v-model="isCheckboxChecked"
              @change="handleSelectAll"
            />
          </div> -->
          <!-- <p style="font-size: 18px; color: #62BDBD; font-weight: 500;">Download</p> -->
        </div>
        <div class="grid-container">
          <div
            class="grid-item"
            v-for="(nav, index) in navList"
            :key="index"
            @click="handleClick(nav)"
          >
            <div v-if="nav.action_code == 'perquisites'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/perquisites.svg')"
                  alt=""
                  class="info_icon"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div v-if="nav.action_code == 'lop'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/leave_attendance.svg')"
                  alt=""
                  class="info_icon"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div v-if="nav.action_code == 'override'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/override.svg')"
                  alt=""
                  class="custom-svg"
                  width="72"
                  height="72"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div v-if="nav.action_code == 'revision'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/scheduled.svg')"
                  alt=""
                  class="info_icon"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div v-if="nav.action_code == 'earningDeduction'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/scheduled.svg')"
                  alt=""
                  class="info_icon"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div v-if="nav.action_code == 'newExit'">
              <div class="validate-payroll-items">
                <img
                  :src="require('@/assets/newjoinee.svg')"
                  alt=""
                  class="info_icon"
                />
                <p>{{ nav.name }}</p>
              </div>
            </div>
            <div
              v-if="nav.PayrollMonthInputValidation[0].status == 'complete'"
              class="status-dot_green"
            ></div>
            <div
              v-if="nav.PayrollMonthInputValidation[0].status == 'incomplete'"
              class="status-dot_red"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 21.5%">
      <div class="pending-container">
        <div style="display: flex" class="heading-items">
          <p class="actionHedaing">Pending Actions</p>
          <img src="@/assets/info-2.svg" style="width: 20px" />
        </div>
        <div
          @click="handleClick(nav)"
          v-for="(nav, key) in navList_pendingactions"
          :key="key"
          class="nav-item"
        >
          <p class="nav-text">{{ nav.name }}</p>
          <div
            v-if="nav.PayrollMonthPendingValidation[0].status == 'incomplete'"
            class="status-circle incomplete"
          >
            <span v-if="nav.action_code == 'pan'">{{
              panCount > 10 ? "9+" : panCount
            }}</span>
            <span v-if="nav.action_code == 'fbp_claim'">{{
              FBPCount > 10 ? "9+" : FBPCount
            }}</span>
            <span v-if="nav.action_code == 'bank_details'">{{
              bankCount > 10 ? "9+" : bankCount
            }}</span>
            <span v-if="nav.action_code == 'it_declaration'">{{
              ITDeclarationCount > 10 ? "9+" : ITDeclarationCount
            }}</span>
            <span v-if="nav.action_code == 'pf_flag'">{{
              pendingPFCount > 10 ? "9+" : pendingPFCount
            }}</span>
          </div>
          <div
            v-if="nav.PayrollMonthPendingValidation[0].status == 'complete'"
            class="status-circle complete"
          >
            <span v-if="nav.action_code == 'pan'">{{
              panCount > 10 ? "9+" : panCount
            }}</span>
            <span v-if="nav.action_code == 'fbp_claim'">{{
              FBPCount > 10 ? "9+" : FBPCount
            }}</span>
            <span v-if="nav.action_code == 'bank_details'">{{
              bankCount > 10 ? "9+" : bankCount
            }}</span>
            <span v-if="nav.action_code == 'it_declaration'">{{
              ITDeclarationCount > 10 ? "9+" : ITDeclarationCount
            }}</span>
            <span v-if="nav.action_code == 'pf_flag'">{{
              pendingPFCount > 10 ? "9+" : pendingPFCount
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 21.5%">
      <div class="statutory-container">
        <div class="statutory-header" style="">
          <p class="actionHedaing">Payroll Actions</p>
          <img src="@/assets/info-2.svg" style="width: 20px" />
        </div>
        <div
          :disabled="disableing"
          v-for="(item, key) in navList_payrollactions"
          :key="key"
          style="
            display: flex;
            gap: 15px;
            row-gap: 20px;
            column-gap: 20px;
            cursor: pointer;
          "
        >
        <!-- remove the comment upto line no 257 to enable release IT proof and it declaration button -->
          <div
            v-if="
              item.action_code != 'fbp_lock' &&
              (item.action_code == 'it_declaration' ||
                item.action_code == 'it_proof')
            "
            @click="
              !greenExists ||
              item.PayrollMonthActionValidation[0].status != 'incomplete'
                ? updateData(item)
                : null
            "
            :class="{
              'grayed-out':
                greenExists &&
                item.PayrollMonthActionValidation[0].status == 'incomplete',
            }"
            style="
              position: relative;
              margin-bottom: 20px;
              display: flex;
              width: 333px;
              align-items: center;
              gap: 25px;
              background-color: #ffffff;
              border: 1px;
              border-radius: 18px;
              padding: 20px 20px;
            "
          >
            <img
              :src="
                item.action_code == 'it_declaration'
                  ? require('@/assets/leave_attendance.svg')
                  : require('@/assets/scheduled.svg')
              "
              alt=""
              class="info_icon"
            />
            <p>{{ item.name }}</p>

            <div class="status-wrapper">
              <div
                v-if="item.PayrollMonthActionValidation[0].status == 'complete'"
                class="status-dot_green"
              ></div>
              <div
                v-if="
                  item.PayrollMonthActionValidation[0].status == 'incomplete'
                "
                class="status-dot_red"
              ></div>
            </div>
          </div> 

          <!-- Third item -->
          <div
            :disabled="item.action_code == 'it_proof'"
            v-if="item.action_code != 'fbp_lock'"
            style="
              gap: 25px;
              margin-bottom: 20px;
              background-color: #ffffff;
              border: 1px;
              border-radius: 24px;
              padding: 40px 25px;
              row-gap: 20px;
              cursor: pointer;
            "
          >
            <img
              src="@/assets/download.svg"
              @click="excelDownloads(item.action_code)"
              style="width: 25px"
              alt=""
            />
          </div>
        </div>
        <div
          @click="payrollAction('FBP Lock')"
          style="
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            border: 1px;
            border-radius: 18px;
            padding: 20px 20px;
            cursor: pointer;
          "
        >
          <div style="display: flex; align-items: center; gap: 25px">
            <img
              :src="require('@/assets/perquisites.svg')"
              alt=""
              class="info_icon"
            />
            <p>FBP Lock</p>
          </div>
          <!-- <img src="@/assets/downloadPayroll.svg" /> -->
        </div>
      </div>
    </div>
    <!-- pop up -->

    <div v-if="messageforpopup == 'lop'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              LOP
            </h3>
            <h3 id="lop" :class="{ active: isRLOPActive }" @click="toggleRLOP">
              RLOP
            </h3>
            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Name</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>LOP</th>
                </tr>
                <tr v-if="isRLOPActive && popupList_rlop.length > 0">
                  <th>Name</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>RLOP</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="isLOPActive && popupList_lop.length > 0"
                  v-for="(item, index) in popupList_lop.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.processing_month_lop }}</td>
                  <td>{{ item.financial_year }}</td>
                  <td>{{ item.deduction_ratio_lop }}</td>
                </tr>
                <tr
                  v-if="isRLOPActive && popupList_rlop.length > 0"
                  v-for="(item, index) in popupList_rlop.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.processing_month_rlop }}</td>
                  <td>{{ item.financial_year }}</td>
                  <td>{{ item.reimbursement_ratio_rlop }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isRLOPActive && popupList_rlop.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div v-if="isLOPActive && popupList_lop.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4 @click="navigateToUpload(messageforpopup)" class="addNew">
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="messageforpopup == 'perquisites'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              Perquisite
            </h3>

            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Name</th>
                  <th>Department</th>
                  <th>Perq Code</th>
                  <th>Perq Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="isLOPActive"
                  v-for="(item, index) in this.popupList_perq.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.month }}</td>
                  <td>{{ item.perquisite_code }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4 @click="navigateToUpload(messageforpopup)" class="addNew">
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="messageforpopup == 'override'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              Earnings & Deductions
            </h3>
            <h3 id="lop" :class="{ active: isRLOPActive }" @click="toggleRLOP">
              TDS Override
            </h3>
            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Name</th>
                  <th>Code</th>
                  <th>E/D Name</th>
                  <th>Monthly Value</th>
                </tr>
                <tr v-if="isRLOPActive">
                  <th>Name</th>
                  <th>Month</th>
                  <th>Tds Override</th>
                  <th>Tds Override Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="isLOPActive && popupList_EarningandDeduction.length > 0"
                  v-for="(item, index) in popupList_EarningandDeduction.slice(
                    0,
                    5
                  )"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.value }}</td>
                </tr>
                <tr
                  v-if="isRLOPActive && popupList_tdsOverride.length > 0"
                  v-for="(item, index) in popupList_tdsOverride.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.month }}</td>
                  <td>{{ item.tds_override }}</td>
                  <td>{{ item.tds_override_value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isRLOPActive && popupList_tdsOverride.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div v-if="isLOPActive && popupList_EarningandDeduction.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4
                @click="navigateToUpload(messageforpopup, isLOPActive)"
                class="addNew"
              >
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="messageforpopup == 'earningDeduction'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              Installments
            </h3>
            <h3 id="lop" :class="{ active: isRLOPActive }" @click="toggleRLOP">
              Tax Outside
            </h3>
            <!-- <h3 id="lop"
              :class="{ active: isRLOPActive }"
              @click="toggleRLOP"> Exits </h3> -->
            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Name</th>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Monthly Value</th>
                  <!-- <th>New joinees</th> -->
                </tr>
                <tr v-if="isRLOPActive">
                  <th>Name</th>
                  <th>Month</th>
                  <th>Tax Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="
                    isLOPActive && popupList_schEarningandDeduction.length > 0
                  "
                  v-for="(
                    item, index
                  ) in popupList_schEarningandDeduction.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.value }}</td>
                </tr>
                <tr
                  v-if="isRLOPActive && popupList_taxOutside.length > 0"
                  v-for="(item, index) in popupList_taxOutside.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.month }}</td>
                  <td>{{ item.tax_amount }}</td>
                  <td>{{ item.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isRLOPActive && popupList_taxOutside.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div
            v-if="isLOPActive && popupList_schEarningandDeduction.length == 0"
          >
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4
                @click="navigateToUpload(messageforpopup, isLOPActive)"
                class="addNew"
              >
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="messageforpopup == 'revision'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              Salary Revision
            </h3>
            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Name</th>
                  <th>Date</th>
                  <th>CTC</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="isLOPActive && popupList_salRevision.length > 0"
                  v-for="(item, index) in popupList_salRevision.slice(0, 5)"
                  :key="index"
                >
                  <td>({{ item.emp_code }})-{{ item.first_name }}</td>
                  <td>{{ item.salary_effective_date }}</td>
                  <td>{{ item.ctc }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isRLOPActive && popupList_salRevision.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div v-if="isLOPActive && popupList_salRevision.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4 @click="navigateToUpload(messageforpopup)" class="addNew">
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="messageforpopup == 'newExit'">
      <div v-if="showUploadandDownloadPopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div style="display: flex; flex-direction: row; gap: 40px">
            <h3 id="lop" :class="{ active: isLOPActive }" @click="toggleLOP">
              New Joiners
            </h3>
            <h3 id="lop" :class="{ active: isRLOPActive }" @click="toggleRLOP">
              Exits
            </h3>
            <img
              @click="excelDownload(isLOPActive, messageforpopup)"
              style="width: 30px; cursor: pointer"
              src="@/assets/reportExcel.svg"
              alt=""
            />
          </div>
          <hr class="popup_separator" />
          <div>
            <table class="reportTable">
              <thead>
                <tr v-if="isLOPActive">
                  <th>Code</th>
                  <th>Name</th>
                  <th>DOJ</th>
                </tr>
                <tr v-if="isRLOPActive">
                  <th>Code</th>
                  <th>Name</th>
                  <th>Processed Date</th>
                  <th>LWD</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="isLOPActive && popupList_newJoinee.length > 0"
                  v-for="(item, index) in popupList_newJoinee.slice(0, 5)"
                  :key="index"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.first_name }}</td>
                  <td>
                    {{ item.EmployeeOfficial.date_of_joining.slice(0, 10) }}
                  </td>
                </tr>
                <tr
                  v-if="isRLOPActive && popupList_exit.length > 0"
                  v-for="(item, index) in popupList_exit.slice(0, 5)"
                  :key="index"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.first_name }}</td>
                  <td>
                    {{
                      item.EmployeeFnf.processed_date
                        ? item.EmployeeFnf.processed_date
                        : "-"
                    }}
                  </td>
                  <td>{{ item.EmployeeFnf.last_working_date }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isRLOPActive && popupList_exit.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div v-if="isLOPActive && popupList_newJoinee.length == 0">
            <h3 style="margin: 145px 0px 0px 275px">
              No Data Found for this Payroll Cycle
            </h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4
                @click="navigateToUpload(messageforpopup, isLOPActive)"
                class="addNew"
              >
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="noDataFoundpopup">
      <div v-if="noDataFoundpopup" class="modal-popup">
        <div class="modal-content_validatepayroll">
          <div class="popup_headers">
            <h3>Alert !!</h3>
          </div>
          <hr class="popup_separator" />
          <div class="alertClass">
            <h3>No Data Found for this Payroll Cycle</h3>
          </div>
          <div class="end_container">
            <hr class="separator_blue_uploadpopup" />
            <div class="endcontainer_components">
              <h4 @click="navigateToUpload(messageforpopup)" class="addNew">
                + Add New
              </h4>
              <button class="btn_cancel_uploadpopup" @click="backUpload">
                Cancel
              </button>
              <button @click="updateData(messageforpopup)" class="btn_primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="incorporationDateIsDraftValidation"
      :message="incorporationValidationMessage"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancel('checkIsAuditApproved')"
          >
            <b>Cancel</b>
          </button>
          <button
            v-show="auditPendingFlag"
            class="btn-popup"
            type="button"
            @click="
              () => {
                incorporationDateIsDraftValidation =
                  !incorporationDateIsDraftValidation;
                releaseItProofForThisMonthPayrollFlag =
                  !releaseItProofForThisMonthPayrollFlag;
                releaseItProofForThisMonthPayroll();
              }
            "
          >
            <b>Confirm</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="releaseItProofForPayroll"
      message="Are you sure  you want to release IT Proof for this month Payroll"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancel()">
            <b>Cancel</b>
          </button>
          <button
            class="btn-popup"
            type="button"
            @click="releaseItproofValidation"
          >
            <b>Confirm</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="successMessage"
      :popupType="'Success'"
      popupHeaderMessage="Success"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="gotoPayroll"
          >
            <b>Back</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showIncorporateDeclaration"
      :message="popupmessage"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelIncorporation"
          >
            <b>No</b>
          </button>
          <button
            class="btn-popup"
            type="button"
            @click="functiontoIncorporateDeclaration1"
          >
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showReleaseITDeclaration"
      :message="popUpMessage"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelReleaseITSherrt"
          >
            <b>No</b>
          </button>
          <button
            class="btn-popup"
            type="button"
            @click="ITDeclarationRelease()"
          >
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="selectAllValidations"
      :message="
        pending_status
          ? 'Please wait while processing...'
          : 'Are you sure you want to validate all items? Once validated, this action cannot be undone!'
      "
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="handaleValidateClose"
          >
            <b>No</b>
          </button>
          <v-btn
            class="btn-pending"
            :loading="pending_status"
            type="button"
            @click="handlevalidate()"
          >
            <b>Yes</b>
          </v-btn>
        </div>
      </template>
    </pop-up-message>
    <v-dialog v-model="showPendingActions" width="500" persistent>
      <v-card>
        <v-card-title class="reportmodal-header">
          <div class="row">
            <h3>{{ this.modalHeader }}</h3>
          </div>
          <div>
            <img
              src="@/assets/group-6.svg"
              class="close-img"
              v-on:click="showPendingActions = false"
              alt=""
            />
          </div>
        </v-card-title>
        <v-card-text v-if="pending_status" class="aduit-card-text">
          <h3>Please wait while processing...</h3>
        </v-card-text>
        <v-card-text v-else class="aduit-card-text">
          <h3>{{ this.popUpMessage }}</h3>
        </v-card-text>
        <v-divider class="divider"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <button
            class="btn_accept_uploadpopup"
            :disabled="pending_status"
            @click="updateData(messageforpopup)"
          >
            Accept & Continue
          </button>
          <button
            @click="excelDownload(true, messageforpopup)"
            :disabled="pending_status"
            class="btn_download"
          >
            Download
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "@/main";
import ExcelJS from "exceljs";

const getPathForStep = (entity_index, step_name) => {
  return `/dashboard/${entity_index}/${step_name}`;
};
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      payrollActions: [
        {
          name: "Transfer IT Declaration",
          icon: require("@/assets/leave_attendance.svg"),
          code: this.it_proof_input_id,
        },
        {
          name: "Transfer IT Proof",
          icon: require("@/assets/scheduled.svg"),
          code: this.it_payroll_input_id,
        },
      ],
      isCheckboxChecked: false,
      disableing: false,
      panDetails: "",
      showPendingActions: false,
      ITDeclaration: "",
      employeeFBP: "",
      bankDetails: "",
      pendingPF: "",
      noDataFoundpopup: false,
      isLOPActive: true,
      showReleaseITSheet: false,
      selectAllValidations: false,
      checkboxDisabled: false,
      showReleaseITDeclaration: false,
      popUpMessage: null,
      modalHeader: null,
      isRLOPActive: false,
      modalHeader: "",
      popupList_lop: [],
      popupList_rlop: [],
      popupList_newJoinee: [],
      popupList_exit: [],
      popupList_schEarningandDeduction: [],
      popupList_taxOutside: [],
      popupList_salRevision: [],
      popupList_perq: [],
      popupList_EarningandDeduction: [],
      popupList_tdsOverride: [],
      popupList: [
        {
          code: "E123",
          name: "Santosh",
          department: "Tech",
          designation: "Software Dev",
          lop: "4",
          rlop: "7",
          doj: "1-Sep-2024",
          doe: "30-Sep-2024",
          perqcode: "SPL-ALW",
          perq: "80000",
          sclcode: "ALZ900",
          monthlyVal: "20000",
          NoofInstallment: "7",
        },
        {
          code: "E123",
          name: "Santosh",
          department: "Tech",
          designation: "Software Dev",
          lop: "4",
          rlop: "7",
          doj: "1-Sep-2024",
          doe: "30-Sep-2024",
          perqcode: "CAR-ALW",
          perq: "55000",
          sclcode: "ALZ900",
          salcomp: "ALZ900",
          prinval: "10000",
          monthlyVal: "20000",
          NoofInstallment: "7",
        },
        {
          code: "E123",
          name: "Santosh",
          department: "Tech",
          designation: "Software Dev",
          lop: "4",
          rlop: "7",
          doj: "1-Sep-2024",
          doe: "30-Sep-2024",
          perqcode: "DRV-ALW",
          perq: "30000",
          sclcode: "ALZ900",
          salcomp: "ALZ900",
          prinval: "10000",
          monthlyVal: "20000",
          NoofInstallment: "7",
        },
      ],
      incorporationDate: false,
      declarationFlag: false,
      enableITProofReleaseButton: false,
      releaseItProofForPayroll: false,
      IncorporationValidationData: {},
      incorporationValidationMessage: "",
      incorporationDateIsDraftValidation: false,
      releaseItProofForThisMonthPayrollFlag: true,
      itProofReleasedForThisMonthPayroll: false,
      auditPendingFlag: true,
      showSuccessMsg: false,
      messageforpopup: "",
      perq_validate_input_id: "",
      initialPickerDate: "",
      startingMonth: "",
      isITProofDisabled: "",
      auditItemsData: [],
      firstPayrollDate: "",
      scheduled_Earning_Deductions_validate_input_id: "",
      lopRlop_validate_input_id: "",
      newjoiners_exit_validate_input_id: "",
      taxpaid_validate_input_id: "",
      override_validate_input_id: "",
      pan_payroll_input_id: "",
      it_declaration_payroll_input_id: "",
      fbp_lock_payroll_input_id: "",
      bank_details_payroll_input_id: "",
      pf_flag_input_id: "",
      it_proof_input_id: "",
      it_payroll_input_id: "",
      fbp_payroll_input_id: "",
      showUploadandDownloadPopup: false,
      showSuccessBulkUploadMsg: false,
      panCount: null,
      bankCount: null,
      ITDeclarationCount: null,
      FBPCount: null,
      pendingPFCount: null,
      items: [
        {
          name: "African Elephant",
          species: "Loxodonta africana",
          diet: "Herbivore",
          habitat: "Savanna, Forests",
        },
      ],
      navList: "",
      navList_pendingactions: "",
      navList_payrollactions: "",
      countDetailsArray: "",
      formattedMonth: "",
      formattedYear: "",
      pending_status: false,
      monthMap: {
        jan: "January",
        feb: "February",
        mar: "March",
        apr: "April",
        may: "May",
        jun: "June",
        jul: "July",
        aug: "August",
        sep: "September",
        oct: "October",
        nov: "November",
        dec: "December",
      },
      pendingPFData: [],
      pendingPANData: [],
      pendingITData: [],
      pendingBankData: [],
      pendingFBPData: [],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapState({
      selectedPayGroupsData: (state) => state.payroll.paygroups.data,
      selectedEmployeesData: (state) => state.payroll.paygroups.employeeData,
      isSelected: (state) => state.payroll.paygroups.isSelectedEmployees,
      totalPayGroupsData: (state) => state.payroll.paygroups.payGroups,
      payrollMonth: (state) => state.payroll.runpayroll.payrollMonth,
      payrollYear: (state) => state.payroll.runpayroll.payrollYear,
      entities: (state) => state.onboard.legal_entities.data,
    }),
    greenExists() {
      return this.navList_payrollactions.some(
        (item) => item.PayrollMonthActionValidation[0].status === "complete"
      );
    },
    formattedCapMonth() {
      let monthCapNumber = parseInt(this.initialPickerDate.split("-")[1], 10);
      monthCapNumber = monthCapNumber === 1 ? 12 : monthCapNumber - 1;

      const monthCapNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      return monthCapNames[monthCapNumber - 1];
    },

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
  },
  date(newValue, oldValue) {},
  selectedItems: {
    handler(newItems, oldItems) {},
    deep: true,
  },
  mounted() {
    this.getDate();
    this.fetchIncorporation();
  },
  methods: {
    ...mapActions({
      act_incorporate_declaration:
        "dashboard/payroll/monthlypayroll/lockPayroll/incorporateDeclaration",
      act_payroll_select_all:
        "dashboard/payroll/monthlypayroll/lockPayroll/getSelectAllItemsPayroll",
      act_validation_before: "payroll/paygroups/fetchValidationDetailsBefore",
      act_getLockedPayrollMonth:
        "dashboard/payroll/monthlypayroll/lockPayroll/getLockedPayrollMonth",
      act_payroll_cycle_data: "onboard/settings/payroll_cycle/fetchAll",
      act_getLOPReport:
        "dashboard/payroll/monthlypayroll/headCount/fetchLOPReport",
      act_getInstallment_Report:
        "dashboard/payroll/monthlypayroll/headCount/fetchInstallmentReport",
      act_getPerqReport:
        "dashboard/payroll/monthlypayroll/headCount/fetchPerqReport",
      act_getNewjoiners_Report:
        "dashboard/payroll/monthlypayroll/headCount/fetchNewJoinersReport",
      act_getExit_Report:
        "dashboard/payroll/monthlypayroll/headCount/fetchExitReport",
      act_getTds_Report:
        "dashboard/payroll/monthlypayroll/headCount/fetchTdsReport",
      act_getValidatePayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/getValidatePayrollApi",
      act_insertValidatePayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/insertValidatePayrollApi",
      act_updateValidatePayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/updateValidatePayrollApi",
      act_perq_popup:
        "dashboard/payroll/monthlypayroll/headCount/perquisitePopup",
      act_earning_deduction_popup:
        "dashboard/payroll/monthlypayroll/headCount/earningDeductionPopup",
      act_lopRlop_popup:
        "dashboard/payroll/monthlypayroll/headCount/lopRlopPopup",
      act_newjoinee_exit_popup:
        "dashboard/payroll/monthlypayroll/headCount/newJoineeandExitPopup",
      act_sal_rev_popup:
        "dashboard/payroll/monthlypayroll/headCount/salaryRevPopup",
      act_schEarningandTaxOutside_popup:
        "dashboard/payroll/monthlypayroll/headCount/schEarningandTaxOutside",
      act_getPayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/getPayrollApi",
      act_insertPayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/insertPayrollApi",
      act_updatePayrollApi:
        "dashboard/payroll/monthlypayroll/headCount/updatePayrollApi",
      act_getPendingActionApi:
        "dashboard/payroll/monthlypayroll/headCount/getPendingActionApi",
      act_insertPendingActionApi:
        "dashboard/payroll/monthlypayroll/headCount/insertPendingActionApi",
      act_updatePendingActionApi:
        "dashboard/payroll/monthlypayroll/headCount/updatePendingActionApi",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_getCount_details: "payroll/paygroups/fetchCountdetails",
      act_getDate: "dashboard/payroll/monthlypayroll/headCount/getDateApi",
      act_getPanFbpItApi:
        "dashboard/payroll/monthlypayroll/headCount/getPanFbpItApi",
      act_sal_rev_Report:
        "dashboard/payroll/monthlypayroll/headCount/salaryRevReport",
      act_itProof_Report:
        "dashboard/payroll/monthlypayroll/headCount/itProofReport",
      act_itDeclaration_Report:
        "dashboard/payroll/monthlypayroll/headCount/itDeclaration",
      act_setPayrollMonth: "payroll/runpayroll/setPayrollMonth",
      act_fetch_incorparation_validation_data:
        "dashboard/itProof/fetchItProofDataForIncorparationDate",
      act_release_itproof: "dashboard/itProof/releaseItproofForPayrollMonth",
    }),
    toggleLOP() {
      this.isLOPActive = !this.isLOPActive;
      this.isRLOPActive = false;
    },
    gotoPayroll() {
      this.showSuccessMsg = false;
      window.location.reload();
    },
    async releaseItProofForThisMonthPayroll() {
      try {
        this.releaseItProofForPayroll = false;

        let payload = {
          legalEntityId: this.le_id,
          financialYear: "2025",
          approvedBy: localStorage.getItem("loginId"),
        };
        let res = await this.act_release_itproof(payload);
        if (res) {
          this.itProofReleasedForThisMonthPayroll = true;
          this.showSuccessMsg = true;
          this.successMessage =
            "Successfully released It Proof Data for this month  payroll";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        this.incorporationDate = false;
      }
    },
    async fetchIncorporation() {
      try {
        let payload = {
          legalEntityId: this.le_id,
          financialYear: "2025",
        };
        let res = await this.act_fetch_incorparation_validation_data(payload);
        if (res.payload) {
          this.IncorporationValidationData = res.payload;
        }
      } catch (err) {}
    },
    async paygroupDetails() {
      try {
        const res = await this.act_getCount_details({
          le_id: this.le_id,
          payroll_month: this.formattedMonth,
          financial_year: this.formattedYear,
        });

        this.countDetailsArray = res.data.payload.data[0].id;
        this.getPayrollInputs();
        this.getPayrollApi();
        this.getPendingApi();
        this.getPanFbpIt();
        // this.selectAllPaygroup()
      } catch (e) {}
    },
    async handleSelectAll(event) {
      if (event.target.checked) {
        // await this.selectAllPaygroup();
        this.selectAllValidations = true;
      }
    },
    async handlevalidate() {
      await this.selectAllPaygroup();
      this.checkboxDisabled = true;
      this.isCheckboxChecked = true;
      this.selectAllValidations = false;
    },
    async handaleValidateClose() {
      this.selectAllValidations = false;
      this.isCheckboxChecked = false;
    },
    async selectAllPaygroup() {
      const res = await this.act_payroll_select_all({
        le_id: this.le_id,
        month: this.formattedMonth,
        year: this.formattedYear,
      });
      if (res.status == 200) {
        this.getPayrollInputs();
        this.getPendingApi();
      }
    },
    async getDate() {
      try {
        let res = await this.act_getDate({ le_id: this.le_id });
        this.formattedMonth = res.data.payload.month;
        this.formattedYear = res.data.payload.financialYear;
        let monthNumber = this.convertMonthToNumber(res.data.payload.month) + 1;
        this.initialPickerDate = `${res.data.payload.financialYear}-${String(
          monthNumber
        ).padStart(2, "0")}`;
        this.paygroupDetails();
        this.getValidation();
        let data = {
          month: this.monthMap[res.data.payload.month],
          year: res.data.payload.financialYear.toString(),
        };
        await this.act_setPayrollMonth(data);
      } catch (e) {
        console.log(e);
      }
    },
    async getPanFbpIt() {
      try {
        this.pending_status = true;

        let res = await this.act_getPanFbpItApi({
          le_id: this.le_id,
          financial_year: this.formattedYear,
          month: this.formattedMonth,
          paygroup_id: this.countDetailsArray,
        });

        if (res.status === 200) {
          let pendingAction = res.data.payload;
          pendingAction.forEach((item) => {
            if (item.type === "Employee_Pan") {
              this.panDetails = item.link;
              this.pendingPANData = item.pendingData;
              this.panCount = item.count;
            } else if (item.type === "Bank_Accounts") {
              this.bankDetails = item.link;
              this.bankCount = item.count;
              this.pendingBankData = item.pendingData;
            } else if (item.type === "IT_Declarations") {
              this.ITDeclaration = item.link;
              this.ITDeclarationCount = item.count;
              this.pendingITData = item.pendingData;
            } else if (item.type === "Employee_fbp") {
              this.employeeFBP = item.link;
              this.FBPCount = item.count;
              this.pendingFBPData = item.pendingData;
            } else if (item.type === "Pending PF") {
              this.pendingPF = item.link;
              this.pendingPFCount = item.count;
              this.pendingPFData = item.pendingData;
            }
          });
          this.pending_status = false;
        }
      } catch (e) {
        console.log(e);
        this.pending_status = false;
      }
    },

    toggleRLOP() {
      this.isRLOPActive = !this.isRLOPActive;
      this.isLOPActive = false;
    },
    ITProofRelease() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          payroll_action_id: this.it_proof_input_id,
        };
        this.updatePayroll(obj);
        this.backUpload();
        this.getValidation();
      } catch (error) {}
    },
    ITDeclarationRelease() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          payroll_action_id: this.it_payroll_input_id,
        };
        this.updatePayroll(obj);
        this.backUpload();
        this.getValidation();
      } catch (error) {}
    },
    async excelDownload(obj, mssg) {
      try {
        if (mssg == "lop") {
          if (obj == true || obj == false) {
            let object = {
              le_id: this.le_id,
              paygroup_id: this.countDetailsArray,
              month: this.formattedMonth,
              year: this.formattedYear,
            };

            let response = await this.act_getLOPReport(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          }
        } else if (mssg == "newExit") {
          if (obj == true) {
            let object = {
              le_id: this.le_id,
              paygroup_id: this.countDetailsArray,
              month: this.formattedMonth,
              year: this.formattedYear,
            };

            let response = await this.act_getNewjoiners_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          } else {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };

            let response = await this.act_getExit_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          }
        } else if (mssg == "override") {
          if (obj == false || obj == true) {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };

            let response = await this.act_getTds_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
            // let object = {
            //   le_id: this.le_id,
            //   month: this.formattedMonth,
            //   year: this.formattedYear,
            //   paygroup_id: this.countDetailsArray,
            // }

            // let response = await this.act_getInstallment_Report(object);
            // if (response && response.data.payload) {
            //   const downloadLink = document.createElement('a');
            //   downloadLink.href = response.data.payload;
            //   document.body.appendChild(downloadLink);
            //   downloadLink.click();
            //   document.body.removeChild(downloadLink);
            // }
          }
        } else if (mssg == "earningDeduction") {
          if (obj == true) {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };

            let response = await this.act_getInstallment_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          } else {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };

            let response = await this.act_getInstallment_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          }
        } else if (mssg == "perquisites") {
          if (obj == true) {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };

            let response = await this.act_getPerqReport(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          }
        } else if (mssg == "revision") {
          if (obj == true) {
            let object = {
              le_id: this.le_id,
              month: this.formattedMonth,
              year: this.formattedYear,
              paygroup_id: this.countDetailsArray,
            };
            let response = await this.act_sal_rev_Report(object);
            if (response && response.data.payload) {
              const downloadLink = document.createElement("a");
              downloadLink.href = response.data.payload;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }
          }
        } else if (mssg == "pan") {
          let workbook = new ExcelJS.Workbook();
          workbook.properties.date1904 = true;

          const font1 = {
            name: "Calibri",
            size: 11,
            underline: false,
            bold: false,
          };

          let worksheet1 = workbook.addWorksheet("Pending PF");

          worksheet1.mergeCells("A2", "P2");
          worksheet1.getCell("C2").value = this.leName || "";
          worksheet1.getCell("C2").alignment = {
            vertical: "middle",
            horizontal: "center",
          };

          worksheet1.mergeCells("A3", "J3");
          let year_month = `${this.formattedMonth}-${this.formattedYear}`;
          worksheet1.getCell("C3").value = `Employees with No Pan: ${year_month
            .charAt(0)
            .toUpperCase()}${year_month.slice(1)}`;
          worksheet1.getCell("C3").alignment = {
            vertical: "middle",
            horizontal: "center",
          };

          worksheet1.getRow(1).hidden = true;

          worksheet1.getRow(3).font = { ...font1, bold: true };
          worksheet1.addRow(["SL. No", "Employee Code", "Employee Name"]);
          worksheet1.getRow(4).font = { ...font1, bold: true };

          this.pendingPANData.forEach((value, index) => {
            const item = {
              sl_no: index + 1,
              employee_code: value.code,
              employee_name: `${value.first_name || ""} ${
                value.last_name || ""
              }`,
            };

            let row = worksheet1.addRow([
              item.sl_no,
              item.employee_code,
              item.employee_name,
            ]);
            row.font = font1;
          });

          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Employee_Pan_Template-${this.le_id}.xlsx`;
          link.click();

          /*  const downloadLink = document.createElement("a");
          downloadLink.href = this.panDetails;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink); */
          this.backUpload();
        } else if (mssg == "it_declaration") {
          const data = JSON.parse(JSON.stringify(this.pendingITData));
          let workbook = new ExcelJS.Workbook();
          workbook.properties.date1904 = true;

          const font1 = { name: "Arial", size: 10, bold: false };

          const year_month = `${this.formattedMonth}-${this.formattedYear}`;
          const sheetsConfig = [
            {
              name: "EmployeeRental",
              key: "pendingRentalEmps",
              title: "Employees with Pending Rental Declaration",
            },
            {
              name: "Section 24",
              key: "pendingSection24Emps",
              title: "Employees with Pending Section24 Declaration",
            },
            {
              name: "Investment",
              key: "pendingChapterVIA",
              title:
                "Employees with Pending Chapter VIA and Section-10 Declarations",
            },
          ];
          console.log(year_month);

          // Create worksheets dynamically based on the sheet configurations
          sheetsConfig.forEach((sheetConfig) => {
            let worksheet = workbook.addWorksheet(sheetConfig.name);
            worksheet.mergeCells("A2", "P2");
            worksheet.getCell("C2").value = this.leName || "";
            worksheet.getCell("C2").alignment = {
              vertical: "middle",
              horizontal: "center",
            };

            worksheet.mergeCells("A3", "J3");
            worksheet.getCell("C3").value = `${sheetConfig.title}: ${year_month
              .charAt(0)
              .toUpperCase()}${year_month.slice(1)}`;
            worksheet.getCell("C3").alignment = {
              vertical: "middle",
              horizontal: "center",
            };
            worksheet.getRow(1).hidden = true;

            worksheet.eachRow(
              { includeEmpty: true },
              (row) => (row.font = font1)
            );

            const columns = [
              { header: "SL No", key: "sl_no", width: 7 },
              { header: "Employee Code", key: "Employee_code", width: 15 },
            ];

            worksheet.getRow(2).font = { bold: true, size: 14 };
            worksheet.getRow(3).font = { bold: true };
            worksheet.getRow(4).font = { bold: true };
            worksheet.getRow(2).height = 25;

            let headers = columns.map((col) => col.header);
            worksheet.getRow(4).values = headers;
            worksheet.columns = columns;

            let pendingEmps = data[sheetConfig.key] || [];
            let index = 1;

            pendingEmps.forEach((emp) => {
              let row = { sl_no: index, Employee_code: emp };
              worksheet.addRow(row);
              index++;
            });
          });

          // Generate and download the file
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Employee_IT_Declaration_Template-${this.le_id}.xlsx`;
          link.click();
          /* const downloadLink = document.createElement("a");
          downloadLink.href = this.ITDeclaration;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink); */
          this.backUpload();
        } else if (mssg == "fbp_claim") {
          let row;
          let workbook = new ExcelJS.Workbook();
          workbook.properties.date1904 = true;
          workbook.views = [
            {
              x: 0,
              y: 0,
              width: 10000,
              height: 20000,
              firstSheet: 0,
              activeTab: 1,
              visibility: "visible",
            },
          ];

          let font1 = {
            name: "Arial",
            family: 5,
            size: 10,
            underline: false,
            bold: false,
          };

          var worksheet1 = workbook.addWorksheet("EmployeeFbpClaim");
          worksheet1.mergeCells("A2", "P2");
          worksheet1.getCell("C2").value = this.leName ? this.leName : "";
          worksheet1.getCell("C2").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          worksheet1.mergeCells("A3", "J3");
          let year_month = this.formattedMonth + "-" + this.formattedYear;
          worksheet1.getCell("C3").value =
            "Employees with Pending FBP claims: " +
            year_month.charAt(0).toUpperCase() +
            year_month.slice(1);
          worksheet1.getCell("C3").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          worksheet1.getRow(1).hidden = true;

          worksheet1.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.font = font1;
          });

          let columns = [
            { header: "SL No", key: "sl_no", width: 7 },
            { header: "Employee Code", key: "Employee_code", width: 15 },
            { header: "Employee ID", key: "employee_id", width: 45 },
            { header: "First Name", key: "first_name", width: 15 },
            { header: "Amount Approved", key: "amount_approved", width: 25 },
            { header: "Bill Date", key: "bill_date", width: 25 },
            { header: "Bill Number", key: "bill_number", width: 25 },
            { header: "Bill Amount", key: "bill_amount", width: 25 },
            { header: "Status", key: "status", width: 15 },
          ];

          worksheet1.getRow(2).font = { bold: true, size: 14 };
          worksheet1.getRow(3).font = { bold: true };
          worksheet1.getRow(4).font = { bold: true };
          worksheet1.getRow(2).height = 25;

          let headers = await columns.map((head) => {
            return head.header;
          });
          let h = await Promise.all(headers);
          worksheet1.getRow(4).values = h;
          worksheet1.columns = columns;

          let index = 1;
          const data = JSON.parse(JSON.stringify(this.pendingFBPData));
          for (let key of data) {
            row = {
              sl_no: index,
              first_name: key.first_name,
              Employee_code: key.code,
              employee_id: key.employee_id,
              amount_approved: "",
              bill_date: key.bill_date,
              bill_number: key.bill_number,
              bill_amount: key.bill_amount,
              status: key.status,
            };
            let insertedRow = worksheet1.addRow(row);
            if (key.status.toLowerCase() === "pending") {
              let statusCell = insertedRow.getCell("status");
              statusCell.font = { color: { argb: "FFFF0000" } }; // Red color for pending status
            }
            index++;
          }
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Employee_Fbp_Claim_Template-${this.le_id}.xlsx`;
          link.click();

          /* const downloadLink = document.createElement("a");
          downloadLink.href = this.employeeFBP;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.backUpload(); */
        } else if (mssg == "bank_details") {
          let row;
          let workbook = new ExcelJS.Workbook();
          workbook.properties.date1904 = true;
          workbook.views = [
            {
              x: 0,
              y: 0,
              width: 10000,
              height: 20000,
              firstSheet: 0,
              activeTab: 1,
              visibility: "visible",
            },
          ];

          let font1 = {
            name: "Arial",
            family: 5,
            size: 10,
            underline: false,
            bold: false,
          };

          var worksheet1 = workbook.addWorksheet("EmployeeBank");
          worksheet1.mergeCells("A2", "P2");
          worksheet1.getCell("C2").value = this.leName ? this.leName : "";
          worksheet1.getCell("C2").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          worksheet1.mergeCells("A3", "J3");
          let year_month = this.formattedMonth + "-" + this.formattedYear;
          worksheet1.getCell("C3").value =
            "Employees with no Bank Details: " +
            year_month.charAt(0).toUpperCase() +
            year_month.slice(1);
          worksheet1.getCell("C3").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          worksheet1.getRow(1).hidden = true;

          worksheet1.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.font = font1;
          });

          let columns = [
            { header: "SL No", key: "sl_no", width: 7 },
            { header: "Employee Code", key: "Employee_code", width: 15 },
            { header: "First Name", key: "first_name", width: 15 },
          ];

          worksheet1.getRow(2).font = { bold: true, size: 14 };
          worksheet1.getRow(3).font = { bold: true };
          worksheet1.getRow(4).font = { bold: true };
          worksheet1.getRow(2).height = 25;

          let headers = await columns.map((head) => {
            return head.header;
          });
          let h = await Promise.all(headers);
          worksheet1.getRow(4).values = h;
          worksheet1.columns = columns;

          let index = 1;

          for (let key of JSON.parse(JSON.stringify(this.pendingBankData))) {
            row = {
              sl_no: index,
              first_name: key.first_name,
              Employee_code: key.code,
            };
            worksheet1.addRow(row);
            index++;
          }
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Employee_Pending_PF_Template-${this.le_id}.xlsx`;
          link.click();
          /*  const downloadLink = document.createElement("a");
          downloadLink.href = this.bankDetails;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.backUpload(); */
        } else if (mssg == "pf_flag") {
          if (this.pendingPFData.length > 0) {
            let workbook = new ExcelJS.Workbook();
            workbook.properties.date1904 = true;

            const font1 = {
              name: "Calibri",
              size: 11,
              underline: false,
              bold: false,
            };

            let worksheet1 = workbook.addWorksheet("Pending PF");

            worksheet1.mergeCells("A2", "P2");
            worksheet1.getCell("C2").value = this.leName || "";
            worksheet1.getCell("C2").alignment = {
              vertical: "middle",
              horizontal: "center",
            };

            worksheet1.mergeCells("A3", "J3");
            let year_month = `${this.formattedMonth}-${this.formattedYear}`;
            worksheet1.getCell("C3").value = `Employees without PF: ${year_month
              .charAt(0)
              .toUpperCase()}${year_month.slice(1)}`;
            worksheet1.getCell("C3").alignment = {
              vertical: "middle",
              horizontal: "center",
            };

            worksheet1.getRow(1).hidden = true;

            worksheet1.getRow(3).font = { ...font1, bold: true };
            worksheet1.addRow(["SL. No", "Employee Code", "Employee Name"]);
            worksheet1.getRow(4).font = { ...font1, bold: true };

            this.pendingPFData.forEach((value, index) => {
              const item = {
                sl_no: index + 1,
                employee_code: value.code,
                employee_name: `${value.first_name || ""} ${
                  value.last_name || ""
                }`,
              };

              let row = worksheet1.addRow([
                item.sl_no,
                item.employee_code,
                item.employee_name,
              ]);
              row.font = font1;
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Employee_Pending_PF_Template-${this.le_id}.xlsx`;
            link.click();
          }
          /*       const downloadLink = document.createElement('a');
          downloadLink.href = this.pendingPF;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.backUpload(); */
        }
      } catch (error) {}
    },
    async excelDownloads(obj) {
      if (obj == "it_proof") {
        let object = {
          le_id: this.le_id,
          financial_year: this.formattedYear,
        };

        let response = await this.act_itProof_Report(object);
        if (response && response.data.payload) {
          const downloadLink = document.createElement("a");
          downloadLink.href = response.data.payload;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      } else if (obj == "it_declaration") {
        let object = {
          le_id: this.le_id,
          financial_year: this.formattedYear,
        };

        let response = await this.act_itDeclaration_Report(object);
        if (response && response.data.payload) {
          const downloadLink = document.createElement("a");
          downloadLink.href = response.data.payload;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      }
    },
    async functiontoCheckEmployeeSavedAsDraft() {
      if (this.IncorporationValidationData.auditValidationPending > 0) {
        this.auditPendingFlag = false;
        this.releaseItProofForThisMonthPayrollFlag = false;
        this.incorporationDateIsDraftValidation = true;
        this.incorporationValidationMessage = `${this.IncorporationValidationData.auditValidationPending} Employees Audit is Pending from Auditor.Please Audit `;
      }
      if (this.IncorporationValidationData.auditValidationPending == 0) {
        this.releaseItProofForPayroll = !this.releaseItProofForPayroll;
      }
    },
    async releaseItproofValidation() {
      this.releaseItProofForPayroll = false;
      if (this.IncorporationValidationData.savedAsDraft > 0) {
        this.incorporationDateIsDraftValidation = true;
        this.incorporationValidationMessage = `${this.IncorporationValidationData.savedAsDraft} Employees were saved as Draft`;
      } else if (this.IncorporationValidationData.savedAsDraft == 0) {
        this.releaseItProofForThisMonthPayrollFlag = true;
        this.releaseItProofForThisMonthPayroll();
      }
    },
    async functiontoIncorporateDeclaration1() {
      try {
        this.releaseItProofForPayroll = false;

        let payload = {
          legalEntityId: this.le_id,
          financialYear: "2024",
          //get it from localstorage
          enabledBy: localStorage.getItem("loginId"),
        };
        let res = await this.act_incorporate_declaration(payload);
        if (res) {
          this.showIncorporateDeclaration = false;
          //  this.itProofReleasedForThisMonthPayroll = true
          this.showSuccessMsg = true;
          this.successMessage = "Successfully Incorporated the Declaration";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        this.incorporationDate = false;
      }
    },
    cancel(params) {
      this.showLockPopup = false;
      this.showUnlockBtn = true;
      this.releaseItProofForPayroll = false;
      this.incorporationDate = false;
      this.incorporationDateIsDraftValidation = false;
      if (params == "checkIsAuditApproved") {
        this.fetchIncorporation();
      }
    },
    async fetchLockMonthAndPayrollCycle() {
      try {
        let obj = { le_id: this.le_id };
        let resone = await this.act_getLockedPayrollMonth(obj);
        let payrollData = resone.data.payload.data[0];
        let monthNames = [
          "jan",
          "feb",
          "mar",
          "apr",
          "may",
          "jun",
          "jul",
          "aug",
          "sep",
          "oct",
          "nov",
          "dec",
        ];
        let monthNumber = this.convertMonthToNumber(payrollData.month) + 1;
        this.initialPickerDate = `${payrollData.financial_year}-${String(
          monthNumber
        ).padStart(2, "0")}`;
        if (resone) {
          this.getPayrollInputs();
          this.getPayrollApi();
          this.getPendingApi();
        }
      } catch (e) {
        try {
          let res = await this.act_payroll_cycle_data(this.le_id);
          this.firstPayrollDate = res.data.payload.data.firstPayroll;
          let startingYear = new Date(this.firstPayrollDate).getFullYear();
          let startingMonth = new Date(this.firstPayrollDate).getMonth() + 1;
          this.startingMonth = startingMonth + 1;
          let monthNames = [
            "jan",
            "feb",
            "mar",
            "apr",
            "may",
            "jun",
            "jul",
            "aug",
            "sep",
            "oct",
            "nov",
            "dec",
          ];
          this.initialPickerDate = `${startingYear}-${String(
            startingMonth
          ).padStart(2, "0")}`;
          if (res) {
            this.getPayrollInputs();
            this.getPayrollApi();
            this.getPendingApi();
          }
        } catch (error) {}
      }
    },
    convertMonthToNumber(monthString) {
      const months = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12,
      };
      return months[monthString.toLowerCase()];
    },

    cancelReleaseITSherrt() {
      this.showReleaseITSheet = false;
      this.showReleaseITDeclaration = false;
    },

    navigateToUpload(item, bool) {
      try {
        if (item == "lop") {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/lopsandrlops`,
          });
        } else if (item == "revision") {
          this.$router.push({
            path: `/dashboard/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/payroll/utilities/revise_salary`,
          });
        } else if (item == "newExit" && bool == false) {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/exits`,
          });
        } else if (item == "newExit" && bool == true) {
          this.$router.push({
            path: `/onboarding/entity/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/employeeDashboard/addEmployee`,
          });
        } else if (item == "earningDeduction" && bool == true) {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/ScheduledEarningsandDeductions`,
          });
        } else if (item == "earningDeduction" && bool == false) {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/taxafterPayroll`,
          });
        } else if (item == "override" && bool == true) {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/variableEarnings`,
          });
        } else if (item == "override" && bool == false) {
          // this.$router.push({
          //   path: `/payroll/run/${
          //     this.$route.params.entity_index
          //       ? this.$route.params.entity_index
          //       : 0
          //   }/tds`,
          // });
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/variableEarnings`,
          });
        } else if (item == "newExit") {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/joinings`,
          });
        } else if (item == "override") {
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/variableEarnings`,
          });
        } else if (item == "perquisites") {
          this.$router.push({
            path: `/dashboard/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/payroll/perquisites`,
          });
        }
      } catch (error) {}
    },

    async updateData(item) {
      try {
        if (item == "perquisites") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id: this.perq_validate_input_id,
          };
          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "earningDeduction") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id:
              this.scheduled_Earning_Deductions_validate_input_id,
          };
          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "lop") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id: this.lopRlop_validate_input_id,
          };
          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "newExit") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id: this.newjoiners_exit_validate_input_id,
          };
          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "revision") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id: this.taxpaid_validate_input_id,
          };
          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "override") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            validate_input_id: this.override_validate_input_id,
          };

          this.updateValidatePayroll(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "pan") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            pending_action_id: this.pan_payroll_input_id,
            remarks: " ",
          };
          this.updatePending(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "it_declaration") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            pending_action_id: this.it_declaration_payroll_input_id,
            remarks: "",
          };

          this.updatePending(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "fbp_claim") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            pending_action_id: this.fbp_lock_payroll_input_id,
            remarks: "",
          };
          this.updatePending(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "bank_details") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            pending_action_id: this.bank_details_payroll_input_id,
            remarks: "",
          };
          this.updatePending(obj);
          this.backUpload();
          this.getValidation();
        } else if (item == "pf_flag") {
          let obj = {
            le_id: this.le_id,
            month: this.formattedMonth,
            year: this.formattedYear,
            pending_action_id: this.pf_flag_input_id,
            remarks: "",
          };
          this.updatePending(obj);
          this.backUpload();
          this.getValidation();
        } else if (item.action_code == "it_proof") {
          this.functiontoCheckEmployeeSavedAsDraft();
        } else if (item.action_code == "it_declaration") {
          this.showReleaseITDeclaration = true;
          this.popUpMessage =
            "Are you sure you want to release it sheet to ESS";
        } else if (item.action_code == "fbp_lock") {
          this.$router.push(
            `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpLock`
          );
        }
      } catch (error) {}
    },
    open() {
      this.showSuccessBulkUploadMsg = true;
    },
    backUpload() {
      this.showSuccessBulkUploadMsg = false;
      this.showUploadandDownloadPopup = false;
      this.noDataFoundpopup = false;
      this.showPendingActions = false;
    },
    formatToDesiredDate(dateString) {
      const date = new Date(dateString);
      const options = {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      };

      return new Intl.DateTimeFormat("en-US", options).format(date);
    },
    async getValidation() {
      try {
        let valiData = [];
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };
        const res = await this.act_validation_before(obj);
        this.getPendingApi();
        this.getOrgLeList();
        this.getPayrollApi();
        this.updateData();
        valiData = res.data.payload;
        this.$emit("vali-data-emitted", valiData);
        const hasIncompleteItems =
          valiData.Actions.length === 0 ||
          valiData.Payroll.length === 0 ||
          valiData.Pending.length === 0 ||
          valiData.Payroll.some((item) => item.status === "incomplete") ||
          valiData.Pending.some((item) => item.status === "incomplete");
        this.checkboxDisabled = !hasIncompleteItems;
        console.log(this.checkboxDisabled, "this.checkboxDisabled");
        if (!hasIncompleteItems) {
          this.isCheckboxChecked = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPayrollInputs() {
      try {
        let auditData = [];
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };

        let response = await this.act_getValidatePayrollApi(obj);
        let res = response.data.payload.result;
        auditData = response.data.payload.result.map((item) => {
          const validation = item.PayrollMonthInputValidation[0];
          return {
            name: validation.modified_by_name,
            id: item.id,
            email: validation.modified_by_email,
            date: this.formatToDesiredDate(validation.updated_at),
            description: item.name,
          };
        });
        this.$emit("audit-data-emitted", auditData);
        if (res.length == 0) {
          this.insertValidatePayroll();
        } else {
          this.navList = response.data.payload.result;
          const actionOrder = [
            "newExit", // New Joiners & Exits
            "lop", // LOP & LOPR
            "revision", // Salary Revision
            "override", // Override Earnings and Statutory Deductions
            "perquisites", // Perquisites
            "earningDeduction", // Scheduled Earning & Deductions
          ];

          // Sort navList based on the defined order
          this.navList.sort((a, b) => {
            return (
              actionOrder.indexOf(a.action_code) -
              actionOrder.indexOf(b.action_code)
            );
          });

          let final_navList = response.data.payload.result;
          final_navList.map((item) => {
            if (item.action_code == "perquisites") {
              this.perq_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
            if (item.action_code == "earningDeduction") {
              this.scheduled_Earning_Deductions_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
            if (item.action_code == "lop") {
              this.lopRlop_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
            if (item.action_code == "newExit") {
              this.newjoiners_exit_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
            if (item.action_code == "revision") {
              this.taxpaid_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
            if (item.action_code == "override") {
              this.override_validate_input_id =
                item.PayrollMonthInputValidation[0].validate_input_id;
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async insertValidatePayroll() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };
        let response = await this.act_insertValidatePayrollApi(obj);
        this.getPayrollInputs();
      } catch (error) {}
    },
    async updateValidatePayroll(object) {
      try {
        let response = await this.act_updateValidatePayrollApi(object);
        this.getPayrollInputs();
      } catch (error) {}
    },
    async getPayrollApi() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };
        let response = await this.act_getPayrollApi(obj);
        let res = response.data.payload.result;

        if (res.length == 0) {
          this.insertPayroll();
        } else {
          this.navList_payrollactions = response.data.payload.result;

          let final_navList = response.data.payload.result;
          final_navList.map((item) => {
            if (item.action_code == "it_proof") {
              item.PayrollMonthActionValidation[0].status = "complete";
              this.it_proof_input_id =
                item.PayrollMonthActionValidation[0].payroll_action_id;
            }
            if (item.action_code == "it_declaration") {
              item.PayrollMonthActionValidation[0].status = "incomplete";
              this.it_payroll_input_id =
                item.PayrollMonthActionValidation[0].payroll_action_id;
            }
            if (item.action_code == "fbp_lock") {
              this.fbp_payroll_input_id =
                item.PayrollMonthActionValidation[0].payroll_action_id;
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async insertPayroll() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };
        let response = await this.act_insertPayrollApi(obj);
        this.getPayrollApi();
      } catch (error) {}
    },
    async updatePayroll(object) {
      try {
        let response = await this.act_updatePayrollApi(object);
        if (response) {
          this.functiontoIncorporateDeclaration1();
        }
        this.getPayrollApi();
        this.showReleaseITDeclaration = false;
        this.showReleaseITSheet = false;
      } catch (error) {}
    },
    async getPendingApi() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };

        let response = await this.act_getPendingActionApi(obj);
        let res = response.data.payload.result;

        if (res.length == 0) {
          this.insertPending();
        } else {
          this.navList_pendingactions = response.data.payload.result;

          let final_navList = response.data.payload.result;
          final_navList.map((item) => {
            if (item.action_code == "pan") {
              this.pan_payroll_input_id =
                item.PayrollMonthPendingValidation[0].pending_action_id;
            }
            if (item.action_code == "it_declaration") {
              this.it_declaration_payroll_input_id =
                item.PayrollMonthPendingValidation[0].pending_action_id;
            }
            if (item.action_code == "fbp_claim") {
              this.fbp_lock_payroll_input_id =
                item.PayrollMonthPendingValidation[0].pending_action_id;
            }
            if (item.action_code == "bank_details") {
              this.bank_details_payroll_input_id =
                item.PayrollMonthPendingValidation[0].pending_action_id;
            }
            if (item.action_code == "pf_flag") {
              this.pf_flag_input_id =
                item.PayrollMonthPendingValidation[0].pending_action_id;
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async insertPending() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        };
        let response = await this.act_insertPendingActionApi(obj);
        this.getPendingApi();
      } catch (error) {}
    },
    async updatePending(object) {
      try {
        let response = await this.act_updatePendingActionApi(object);
        if (response) {
          this.functiontoIncorporateDeclaration1();
        }
        this.getPendingApi();
      } catch (error) {}
    },
    async perqPopup(item) {
      try {
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_perq_popup(obj);
        if (response.data.payload.earningAndDeduction.data.length > 0) {
          let response_perq = response.data.payload.earningAndDeduction.data;
          this.popupList_perq = response_perq;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.noDataFoundpopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async newJoineeandExitPopup(item) {
      try {
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_newjoinee_exit_popup(obj);
        if (
          response.data.payload.exitEmployees.data.length > 0 ||
          response.data.payload.newJoinees.data.length > 0
        ) {
          let response_newJoinee = response.data.payload.newJoinees.data;
          let response_exit = response.data.payload.exitEmployees.data;
          this.popupList_newJoinee = response_newJoinee;
          this.popupList_exit = response_exit;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async salRevPopup(item) {
      try {
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_sal_rev_popup(obj);
        if (response.data.payload.salaryRev.data.length > 0) {
          let response_taxOutside = response.data.payload.salaryRev.data;
          this.popupList_salRevision = response_taxOutside;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.noDataFoundpopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async earningDeductionPopup(item) {
      try {
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_earning_deduction_popup(obj);

        if (
          response.data.payload.earningAndDeduction.data.length > 0 ||
          response.data.payload.tdsOverride.data.length > 0
        ) {
          let response_EarningandDeduction =
            response.data.payload.earningAndDeduction.data;
          let response_tdsOverride = response.data.payload.tdsOverride.data;
          this.popupList_EarningandDeduction = response_EarningandDeduction;
          this.popupList_tdsOverride = response_tdsOverride;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async lopRlopPopup(item) {
      try {
        this.messageforpopup = item;
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_lopRlop_popup(obj);
        let response_lop = response.data.payload.lopData;
        let response_rlop = response.data.payload.rlopData;

        if (
          response.data.payload.lopData.data.length > 0 ||
          response.data.payload.rlopData.data.length > 0
        ) {
          let response_lop = response.data.payload.lopData.data;
          let response_rlop = response.data.payload.rlopData.data;
          this.popupList_lop = response_lop;
          this.popupList_rlop = response_rlop;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.noDataFoundpopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async schEarningandTaxOutsidePopup(item) {
      try {
        let obj = {
          le_id: this.le_id,
          paygroup_id: this.countDetailsArray,
          month: this.formattedCapMonth,
          financial_year: this.formattedYear,
        };
        let response = await this.act_schEarningandTaxOutside_popup(obj);
        if (
          response.data.payload.earningAndDeduction.data.length > 0 ||
          response.data.payload.taxOutside.data.length > 0
        ) {
          let response_schEarningandDeduction =
            response.data.payload.earningAndDeduction.data;
          let response_taxOutside = response.data.payload.taxOutside.data;
          this.popupList_schEarningandDeduction =
            response_schEarningandDeduction;
          this.popupList_taxOutside = response_taxOutside;
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        } else {
          this.showUploadandDownloadPopup = true;
          this.messageforpopup = item;
        }
      } catch (error) {}
    },
    async handleClick(nav) {
      //console.log('Clicked item:', nav);
      if (nav.action_code == "lop") {
        let Response = this.lopRlopPopup("lop");
      } else if (nav.action_code == "newExit") {
        let Response = this.newJoineeandExitPopup("newExit");
      } else if (nav.action_code == "earningDeduction") {
        let Response = this.schEarningandTaxOutsidePopup("earningDeduction");
      } else if (nav.action_code == "revision") {
        let Response = this.salRevPopup("revision");
      } else if (nav.action_code == "perquisites") {
        let Response = this.perqPopup("perquisites");
      } else if (nav.action_code == "override") {
        let Response = this.earningDeductionPopup("override");
      } else if (nav.action_code == "pan") {
        this.showPendingActions = true;
        this.messageforpopup = "pan";
        this.popUpMessage = "Are you sure you want to accept Pan details";
        this.modalHeader = "Pan Card";
      } else if (nav.action_code == "it_declaration") {
        this.showPendingActions = true;
        this.messageforpopup = "it_declaration";
        this.popUpMessage =
          "Are you sure you want to accept IT Declaration details";
        this.modalHeader = "IT Declaration";
      } else if (nav.action_code == "fbp_claim") {
        this.showPendingActions = true;
        this.messageforpopup = "fbp_claim";
        this.popUpMessage = "Are you sure you want to accept FBP Claim details";
        this.modalHeader = "FBP Claim";
      } else if (nav.action_code == "bank_details") {
        this.showPendingActions = true;
        this.messageforpopup = "bank_details";
        this.popUpMessage = "Are you sure you want to accept Bank details";
        this.modalHeader = "Bank Details";
      } else if (nav.action_code == "pf_flag") {
        this.showPendingActions = true;
        this.messageforpopup = "pf_flag";
        this.popUpMessage = "Are you sure you want to accept pending PF";
        this.modalHeader = "PF Flag";
      }
    },

    payrollAction(nav) {
      if (nav.name == "Transfer IT Declaration") {
        this.showReleaseITSheet = true;
        this.popUpMessage = "Are you sure you want to release it sheet to ESS";
      } else if (nav.name == "Transfer IT Proof") {
        this.showReleaseITSheet = true;
        this.popUpMessage =
          "Are you sure you want to release IT Proof for this month Payroll";
      } else if (nav == "FBP Lock") {
        this.$router.push(
          `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpLock`
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.disabled-item {
  pointer-events: none;
}
.main-containers {
  display: flex;
  gap: 20px;
  margin: 20px 30px;
  padding-bottom: 20px;
  width: 100%;
}
.validate-container {
  background: white;
  height: 420px;
  padding: 20px 25px;
  border: 2px solid #eeeeee;
  border-radius: 18px;
  cursor: pointer;
}
.validate_container-stepper {
  display: flex;
  justify-content: space-between;
}
.info_icon {
  width: 72px;
  height: 72px;
}
.reportmodal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 50px;
  padding: 20px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border: solid 1px #f0f0f0;
  background-color: #ffffff;

  h3 {
    font-weight: 600;
    color: #5d409f;
  }
}

.pending-container,
.payrollAction-container {
  background: white;
  height: 420px;
  padding: 20px 25px;
  border: 2px solid #eeeeee;
  border-radius: 18px;
}
.validate-payroll-items {
  display: flex;
  gap: 25px;
  align-items: center;
}
.status-dot_green {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
  margin-left: auto;
  background-color: #00b430;
}
.status-dot_red {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
  margin-left: auto;
  background-color: #e80000;
}
.actionHedaing {
  margin-bottom: 0px;
  color: #59419a;
  font-size: 18px;
  font-weight: 500;
}

.heading-items {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.grid-container {
  margin-top: 25px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  border: 1px solid #c1c1c1;
  border-radius: 18px;
}

.grid-item:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}

.validate-payroll-items p {
  transition: color 0.3s ease;
}

.grid-item:hover .validate-payroll-items p {
  color: #000000;
  font-weight: 550;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #c1c1c1;
  border-radius: 18px;
  padding: 8px;
  margin-top: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.nav-item:hover {
  background-color: #f0f0f0;
}

.nav-text {
  margin-bottom: 6px;
  transition: color 0.3s ease;
}
.nav-item:hover .nav-text {
  color: #000;
  font-weight: 550;
}
.status-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: white;
}

.incomplete {
  border: 2px solid #e80000;
}

.complete {
  border: 2px solid #00b430;
}
.statutory-container {
  display: flex;
  flex-direction: column;
}

.statutory-header {
  display: flex;
  margin-bottom: 20px;
  gap: 10px;
}

.modal-popup {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

.modal-content_validatepayroll {
  background-color: #ffffff;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 864px;
  height: 459px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  border-radius: 12px;
  -webkit-animation-name: showPopup-e576876a;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.popup_headers {
  display: flex;
  justify-content: space-between;
  padding: 17px 5px 5px 35px;
}

.alertClass {
  margin: 145px 0px 0px 275px;
}

.popup_separator {
  width: 100%;
  height: 0.037109375px;
  border: 1px solid #cbcbcb;
}

.reportTable {
  border-collapse: collapse;
  font-size: 1rem;
  width: 864px;
}

.reportTable thead tr {
  background-color: #a2a1a123;
  height: 50px;
  text-align: left;
}

.reportTable th,
.reportTable td {
  padding: 0 20px 8px;
}
.aduit-card-text {
  padding: 22px 20px;
  max-height: 250px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.reportTable td:last-child {
  width: 25%;
}
.reportTable tbody tr {
  height: 50px;
  text-align: left;
  font-weight: 400;
  border-bottom: 0.5px solid #dddddd;
}

.status-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
}

.reportTable tbody tr:last-child {
  border-bottom: none;
}

.end_container {
  position: fixed;
  margin-top: 385px;
}

.separator_blue_uploadpopup {
  width: 864px;
  height: 0.363037109375px;
  background: #376cd3 0% 0% no-repeat padding-box;
  border: 1px solid #34c0bd79;
}

.endcontainer_components {
  display: flex;
}

.btn_cancel_uploadpopup {
  margin: 20px 15px 15px 450px;
  font-weight: 600;
  width: 138px;
  height: 34px;
  border: 2px solid #59419a;
  border-radius: 6px;
  font-style: normal normal 900 12px/15px Montserrat;
  letter-spacing: 0px;
  color: #5d409f;
}
.btn_accept_uploadpopup {
  font-weight: 600;
  width: 160px;
  height: 34px;
  border: 2px solid #59419a;
  border-radius: 6px;
  font-style: normal normal 900 12px/15px Montserrat;
  letter-spacing: 0px;
  color: #5d409f;
}
.addNew {
  width: 90px;
  cursor: pointer;
  margin: 26px 0px 0px 15px;
  color: #5d409f;
}
.grayed-out {
  opacity: 0.5; /* Adjust the opacity to make the item look disabled */
  filter: grayscale(
    100%
  ); /* Optional: adds a grayscale effect to further indicate it's disabled */
}
.btn_primary {
  margin-top: 20px;
  width: 138px;
  height: 34px;
  font-weight: 600;
  background: #5d409f 0% 0% no-repeat padding-box;
  border-radius: 6px;
  font-style: normal normal 900 12px/15px Montserrat;
  letter-spacing: 0px;
  color: #ffffff;
}
.custom-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #62bdbd;
}

.custom-checkbox:checked {
  accent-color: #62bdbd; /* Checkbox background color */
  color: white; /* Checkmark color */
}

.btn_download {
  width: 138px;
  height: 34px;
  font-weight: 600;
  background: #5d409f;
  border-radius: 6px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-left: 10px;
}
#lop {
  margin: 0;
  padding: 10px;
  cursor: pointer;
  min-width: none;
  width: auto;
}

#lop.active {
  border-bottom: 3px solid #34c0bd;
  min-width: none;
  width: auto;
}

.btn-pending {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #5d409f !important;
  color: #ffffff;
  text-transform: capitalize;
  margin: 0px !important;
}
</style>
